// components/AssetDescription/AssetDescription.tsx
import React from 'react';
import parse from 'html-react-parser';
import TruncateReadmore from '@/components/TruncateReadmore/TruncateReadmore';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';
interface AssetDescriptionProps {
  /**
   * The resource description text to display
   */
  resDesc: string;
  /**
   * Validation parameters that determine how the description is displayed
   */
  validationParams?: {
    leadDropValidation?: boolean;
    customerLinks?: boolean;
    peDemandSub?: boolean;
  };
}

/**
 * AssetDescription component renders the asset description text
 * with conditional truncation based on validation parameters
 */
const AssetDescription: React.FC<AssetDescriptionProps> = ({
  resDesc,
  validationParams
}) => {
  const sanitizedDescription = sanitizeTitle(resDesc);
  return <div className={'assets-description'} data-sentry-component="AssetDescription" data-sentry-source-file="AssetDescription.tsx">
      {validationParams?.leadDropValidation ? <TruncateReadmore classToken={'client-description'} numberOfLines={7} trimBy={'words'} text={sanitizedDescription} /> : parse(sanitizedDescription)}
    </div>;
};
export default AssetDescription;